import lodashCloneDeep from 'lodash/cloneDeep'

export const setFileStatusActionType = 'setFileStatusActionType';

export function setFileStatusAction(id, status, progress) {
    return {
        type: setFileStatusActionType,
        payload: {
            id: id,
            status: status,
            progress: progress,
        }
    }
}

export function setFileStatusHandler(state, action) {
    const { id, status, progress } = action.payload;
    let newState = lodashCloneDeep(state);

    let index = newState.queue.findIndex(function(queueItem) {
        return queueItem.id == id;
    });
    
    if (index != -1) {
        Object.assign(newState.queue[index], { status: status, progress: progress });
    }

    return newState;
}
